export default "__VITE_ASSET__C_Qn7hVJ__"